// AXIOS SETUP
import axios from "axios"
import { store } from "./store/store-init"

const version = "1.3.1"; // Contenidos estáticos y API v1.12.0, ajuste ligero de botón de WhatsApp.
const mode = "prod"; // change this to "docker", "dev", or "prod"

let mainServer,
    isDev = false;

switch (mode) {
    case 'docker':
        mainServer = 'http://localhost:8001/refaapp-api';
        // mainServer = 'https://4e55-189-182-123-157.ngrok-free.app/refaapp-api';
        isDev = true;
        break;
    case 'dev':
        mainServer = 'https://api.refaapp.com/dev';
        isDev = true;
        break;
    case 'alpha':
        mainServer = 'https://api.refaapp.com/alpha';
        break;
    case 'prod':
        default:
        mainServer = 'https://api.refaapp.com/prod';
        break;
}

axios.defaults.maediaImageRender = mainServer + '/index.php?r=img/render/';
axios.defaults.timeout = 30000
axios.defaults.withCredentials = false;
axios.defaults.switchAPI = (waty) => {
    switch (waty) {
        case 'consumer':
            axios.defaults.baseURL = mainServer + '/index.php?r=api'
            axios.defaults.isSales = false
            break;
    }
}
axios.defaults.switchAPI('consumer')

axios.interceptors.request.use((config) => {

    // Do something before request is sent
    config.headers['Content-Type'] = 'application/json';

    if (!!store.getters.accountGetToken)
        config.headers['AUTH-TOKEN'] = store.getters.accountGetToken;
    else if (typeof config.headers['AUTH-TOKEN'] != 'undefined')
        delete config.headers['AUTH-TOKEN'];

    if (!!axios.defaults.headers.common && !!axios.defaults.headers.common['X-Requested-With'])
        delete axios.defaults.headers.common['X-Requested-With'];

    return config;

}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {
    // Do something with response data
    let returnable = response.data
    return returnable
}, (error) => {
    // Do something with response error
    return Promise.reject(error);
});

export { isDev, mainServer, version }